import EditorEnhancerModal from '@/components/editor/EditorEnhancerModal.vue';
import { setting } from '@/Helpers.js';
import { ModalService } from '@/services/ModalService.js';
import snackbarService from '@/services/SnackbarService.js';

const throwError = message => {
    snackbarService.open({
        message,
        type: 'is-danger',
        position: 'is-bottom-left',
        actionText: 'Dismiss',
        duration: 5000,
    });
};

export default {
    title: 'EdverumAI Text Enhancer',

    icon: 'enhance',

    focus: true,

    undo: true,

    refreshAfterCallback: true,

    callback() {
        const editor = this;

        const selection = editor.selection.get();
        const hasNoSelection = !selection || selection.toString().trim() === '';
        const text = hasNoSelection ? editor.html.get() : selection.toString();
        const maxLength = setting('enhancement_text_max_length');

        if (!text.length) {
            throwError('The text to enhance cannot be empty.');

            return;
        }

        if (text.length > maxLength) {
            throwError(`The text to enhance cannot exceed ${maxLength} characters.`);

            return;
        }

        let activeRange = null;

        if (selection && selection.rangeCount > 0) {
            activeRange = selection.getRangeAt(0).cloneRange();
        }

        ModalService.open({
            component: EditorEnhancerModal,

            props: { text },

            hasModalCard: true,

            trapFocus: true,

            width: '600px',

            canCancel: ['escape', 'outside'],

            customClass: 'is-transparent-background-modal',

            events: {
                accept: enhancedText => {
                    editor.events.focus();

                    if (activeRange) {
                        const currentSelection = editor.selection.get();

                        if (currentSelection) {
                            currentSelection.removeAllRanges();

                            currentSelection.addRange(activeRange);
                        }
                    }

                    if (hasNoSelection) {
                        editor.html.set(enhancedText);
                    } else {
                        editor.html.insert(enhancedText, false);
                    }

                    editor.events.trigger('contentChanged');
                },
            },
        });
    },
};
